// extracted by mini-css-extract-plugin
module.exports = {"inlineBlock":"StatementDescriptor_inlineBlock__15UP7","validationTips":"StatementDescriptor_validationTips__1esRu"};